<template>
  <!-- 学历信息 -->
  <div class="person-info">
    <h3>
      <i></i>
      <span>学历信息</span>
      <div class="edit" @click="editInfo" v-if="!onEdit && hasFinished"><img src="../../assets/edit_icon.png"> 编辑</div>
    </h3>
    <div class="person-box">
      <section class="select-sec">
        <label class="tit">第&nbsp;&nbsp;&nbsp;&nbsp;一&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;历：</label>
        <div class="con">
          <el-select v-model="firstDegree" placeholder="请选择" v-if="!hasFinished || onEdit" @change="getFirstDegree">
            <el-option v-for="(degree, key) in educationInfo.dicEducations" :key="key" :label="degree" :value="key"></el-option>
          </el-select>
          <div class="txt" v-if="!onEdit && hasFinished">{{firstDegreeName}}</div>
        </div>
        <span class="error" v-if="fdegreeErr">请选择第一学历</span>
      </section>
      <section>
        <label class="tit">第一学历毕业学校：</label>
        <div class="con">
          <el-input v-model="firstSchool" value="" v-if="!hasFinished || onEdit" @focus="fschoolFocus" placeholder="第一学历毕业学校"></el-input>
          <div class="txt" v-if="!onEdit && hasFinished">{{firstSchool}}</div>
        </div>
        <span class="error" v-if="fschoolErr">请填写第一学历毕业学校</span>
      </section>
      <section>
        <label class="tit">第一学历毕业专业：</label>
        <div class="con">
          <el-input v-model="firstMajor" value="" v-if="!hasFinished || onEdit" @focus="fmajorFocus" placeholder="第一学历毕业专业"></el-input>
          <div class="txt" v-if="!onEdit && hasFinished">{{firstMajor}}</div>
        </div>
        <span class="error" v-if="fmajorErr">请填写第一学历毕业专业</span>
      </section>
      <section class="select-sec">
        <label class="tit" style="letter-spacing: 4.2px;">第一学历学制：</label>
        <div class="con">
          <el-select v-model="firstDegreeType" placeholder="请选择" v-if="!hasFinished || onEdit" @change="getFirstDegreeType">
            <el-option v-for="(degreeType, key) in educationInfo.dicSchoolLenth" :key="key" :label="degreeType" :value="key"></el-option>
          </el-select>
          <div class="txt" v-if="!onEdit && hasFinished">{{firstDegreeTypeName}}</div>
        </div>
        <span class="error" v-if="fdegreeTypeErr">请选择第一学历学制</span>
      </section>
      <section class="select-sec" style="margin-top: 50px;">
        <label class="tit">最&nbsp;&nbsp;&nbsp;&nbsp;高&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;历：</label>
        <div class="con">
          <el-select v-model="highDegree" placeholder="请选择" v-if="!hasFinished || onEdit" @change="getHighDegree">
            <el-option v-for="(degree, key) in educationInfo.dicEducations" :key="key" :label="degree" :value="key"></el-option>
          </el-select>
          <div class="txt" v-if="!onEdit && hasFinished">{{highDegreeName}}</div>
        </div>
        <span class="error" v-if="hdegreeErr">请选择最高学历</span>
      </section>
      <section>
        <label class="tit">最高学历毕业学校：</label>
        <div class="con">
          <el-input v-model="highSchool" value="" v-if="!hasFinished || onEdit" @focus="hschoolFocus" placeholder="最高学历毕业学校"></el-input>
          <div class="txt" v-if="!onEdit && hasFinished">{{highSchool}}</div>
        </div>
        <span class="error" v-if="hschoolErr">请填写最高学历毕业学校</span>
      </section>
      <section>
        <label class="tit">最高学历毕业专业：</label>
        <div class="con">
          <el-input v-model="highMajor" value="" v-if="!hasFinished || onEdit" @focus="hmajorFocus" placeholder="最高学历毕业专业"></el-input>
          <div class="txt" v-if="!onEdit && hasFinished">{{highMajor}}</div>
        </div>
        <span class="error" v-if="hmajorErr">请填写最高学历毕业专业</span>
      </section>
      <section class="select-sec">
        <label class="tit" style="letter-spacing: 4.2px;">最高学历学制：</label>
        <div class="con">
          <el-select v-model="highDegreeType" placeholder="请选择" v-if="!hasFinished || onEdit" @change="getHighDegreeType">
            <el-option v-for="(degreeType, key) in educationInfo.dicSchoolLenth" :key="key" :label="degreeType" :value="key"></el-option>
          </el-select>
          <div class="txt" v-if="!onEdit && hasFinished">{{highDegreeTypeName}}</div>
        </div>
        <span class="error" v-if="hdegreeTypeErr">请选择最高学历学制</span>
      </section>
      <section class="btn" v-if="!hasFinished || onEdit">
        <label class="tit">&nbsp;</label>
        <div class="con">
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import api from '../../utils/api'
export default {
  props: ['educationInfo'],
  data () {
    return {
      hasFinished: this.educationInfo.finishStatus, // 是否已经完成编辑
      firstDegree: '',
      firstDegreeName: this.educationInfo.firstEducationName,
      firstSchool: this.educationInfo.firstEduSchool,
      firstMajor: this.educationInfo.firstEduMajor,
      firstDegreeType: '',
      firstDegreeTypeName: this.educationInfo.firstSchoolLenthName,
      highDegree: '',
      highDegreeName: this.educationInfo.highestEduName,
      highSchool: this.educationInfo.highestEduSchool,
      highMajor: this.educationInfo.firstEduMajor,
      highDegreeType: '',
      highDegreeTypeName: this.educationInfo.highestSchoolLenthName,
      eduObj: this.educationInfo.dicEducations, // 学历下拉选项
      degreeObj: this.educationInfo.dicSchoolLenth, // 学制下拉选项
      // 错误信息提示
      fdegreeErr: false,
      fschoolErr: false,
      fmajorErr: false,
      fdegreeTypeErr: false,
      hdegreeErr: false,
      hschoolErr: false,
      hmajorErr: false,
      hdegreeTypeErr: false,
      // 编辑
      onEdit: false
    }
  },
  mounted () {
    // 未提交信息
    let eduInfoLocal = window.sessionStorage.getItem('eduInfoLocal')
    if (eduInfoLocal) {
      let info = JSON.parse(eduInfoLocal)
      // console.log(info)
      this.hasFinished = info.finishStatus
      this.firstDegreeName = info.firstDegreeName
      this.firstSchool = info.firstSchool
      this.firstMajor = info.firstMajor
      this.firstDegreeTypeName = info.firstDegreeTypeName
      this.highDegreeName = info.highDegreeName
      this.highSchool = info.highSchool
      this.highMajor = info.highMajor
      this.highDegreeTypeName = info.highDegreeTypeName
    } else if (this.educationInfo.firstDegreeName !== '') {
      this.hasFinished = this.educationInfo.finishStatus
      this.firstDegreeName = this.educationInfo.firstEducationName
      this.firstSchool = this.educationInfo.firstEduSchool
      this.firstMajor = this.educationInfo.firstEduMajor
      this.firstDegreeTypeName = this.educationInfo.firstSchoolLenthName
      this.highDegreeName = this.educationInfo.highestEduName
      this.highSchool = this.educationInfo.highestEduSchool
      this.highMajor = this.educationInfo.highestEduMajor
      this.highDegreeTypeName = this.educationInfo.highestSchoolLenthName
    }
    this.userId = window.sessionStorage.getItem('userId')
  },
  methods: {
    // 第一学历
    getFirstDegree (val) {
      for (let i in this.eduObj) {
        if (val === i) {
          this.firstDegreeName = this.eduObj[i]
        }
      }
      this.fdegreeErr = false
    },
    // 第一学历学校
    fschoolFocus () {
      this.fschoolErr = false
    },
    // 第一学历学校
    fmajorFocus () {
      this.fmajorErr = false
    },
    // 第一学历学制
    getFirstDegreeType (val) {
      for (let i in this.degreeObj) {
        if (val === i) {
          this.firstDegreeTypeName = this.degreeObj[i]
        }
      }
      this.fdegreeTypeErr = false
    },
    // 最高学历
    getHighDegree (val) {
      for (let i in this.eduObj) {
        if (val === i) {
          this.highDegreeName = this.eduObj[i]
        }
      }
      this.hdegreeErr = false
    },
    // 最高学历学校
    hschoolFocus () {
      this.hschoolErr = false
    },
    // 最高学历专业
    hmajorFocus () {
      this.hmajorErr = false
    },
    // 最高学历学制
    getHighDegreeType (val) {
      for (let i in this.degreeObj) {
        if (val === i) {
          this.highDegreeTypeName = this.degreeObj[i]
        }
      }
      this.hdegreeTypeErr = false
    },
    // 提交
    onSubmit () {
      let _this = this
      if (_this.firstDegree === '') {
        _this.fdegreeErr = true
        return false
      }
      if (_this.firstSchool === '') {
        _this.fschoolErr = true
        return false
      }
      if (_this.firstMajor === '') {
        _this.fmajorErr = true
        return false
      }
      if (_this.firstDegreeType === '') {
        _this.fdegreeTypeErr = true
        return false
      }
      if (_this.highDegree === '') {
        _this.hdegreeErr = true
        return false
      }
      if (_this.highSchool === '') {
        _this.hschoolErr = true
        return false
      }
      if (_this.highMajor === '') {
        _this.hmajorErr = true
        return false
      }
      if (_this.highDegreeType === '') {
        _this.hdegreeTypeErr = true
        return false
      }
      _this.submitInfo()
    },
    submitInfo () {
      let _this = this
      let eduInfo = {
        userId: _this.userId,
        firstEducation: parseInt(_this.firstDegree),
        firstEduSchool: _this.firstSchool,
        firstEduMajor: _this.firstMajor,
        firstSchoolLenth: parseInt(_this.firstDegreeType),
        highestEdu: parseInt(_this.highDegree),
        highestEduSchool: _this.highSchool,
        highestEduMajor: _this.highMajor,
        highestSchoolLenth: parseInt(_this.highDegreeType),
        finishStatus: false
      }
      api.post('SaveSZTeacherPersonalInfoRequest', {
        part: 2,
        eduInfo: eduInfo
      }, res => {
        console.log(res)
        _this.$message({
          message: '学历信息保存成功',
          type: 'success'
        })
        let eduInfoLocal = {
          finishStatus: true,
          firstDegreeName: _this.firstDegreeName,
          firstSchool: _this.firstSchool,
          firstMajor: _this.firstMajor,
          firstDegreeTypeName: _this.firstDegreeTypeName,
          highDegreeName: _this.highDegreeName,
          highSchool: _this.highSchool,
          highMajor: _this.highMajor,
          highDegreeTypeName: _this.highDegreeTypeName
        }
        window.sessionStorage.setItem('eduInfoLocal', JSON.stringify(eduInfoLocal))
        _this.hasFinished = true
        if (!_this.onEdit) {
          _this.$emit('hasFinish', 1)
        } else {
          _this.onEdit = false
        }
      })
    },
    // 编辑
    editInfo () {
      console.log('edit')
      this.onEdit = true
      this.firstDegree = this.getKey(this.firstDegreeName, this.educationInfo.dicEducations)
      this.firstSchool = this.firstSchool
      this.firstMajor = this.firstMajor
      this.firstDegreeType = this.getKey(this.firstDegreeTypeName, this.educationInfo.dicSchoolLenth)
      this.highDegree = this.getKey(this.highDegreeName, this.educationInfo.dicEducations)
      this.highSchool = this.highSchool
      this.highMajor = this.highMajor
      this.highDegreeType = this.getKey(this.highDegreeTypeName, this.educationInfo.dicSchoolLenth)
    },
    // 根据value获取key
    getKey (value, valueObj) {
      for (let i in valueObj) {
        if (value === valueObj[i]) {
          return i
        }
      }
    }
  },
  watch: {
    educationInfo (val) {
      console.log(val)
    }
  }
}
</script>
<style scoped>
  .person-info h3 {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: normal;
  }
  .person-info h3 i {
    width: 2px;
    height: 16px;
    background: #FE793A;
    margin-right: 10px;
  }

  .person-info h3 span {
    flex: 1;
  }

  .person-info h3 .edit {
    color: #FE793A;
    font-size: 12px;
    cursor: pointer;
  }

  .person-info h3 .edit img {
    width: 12px;
    height: 12px;
    vertical-align: middle;
    margin-bottom: 3px;
  }
  .person-box {
    margin-top: 24px;
  }
  .person-box section {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .person-box section .tit {
    width: 130px;
    font-size: 14px;
    color: #333;
  }
  .person-box section .con {
    /* width: 320px; */
    width: 237px;
    margin-left: 5px;
  }
  .person-box section .con .el-input {
    /* width: 300px; */
    width: 217px;
  }
  .person-box section .txt {
    font-size: 14px;
  }
  .person-box section .error {
    width: 230px;
    text-align: left;
    font-size: 12px;
    color: #ff0000;
  }
  .person-box section.btn {
    margin-top: 40px;
  }
  .w35 {
    width: 35.5%;
  }
</style>
